export const API_BASE_URI = '/xlzc_website_server/index.php/portal_website'



// WEBPACK FOOTER //
// ./src/config.js